import { Route, Routes } from 'react-router-dom';
import { Campaigns } from './components/Campaigns';
import { CampaignGoals } from './components/CampaignGoals';
import { CampaignGoalForm } from './components/CampaignGoalForm';
import { CampaignType } from './components/CampaignType';
import { CampaignTypeForm } from './components/CampaignTypeForm';
import { CampaignBudgetRange } from './components/CampaignBudgetRange';
import { CampaignBudgetRangeForm } from './components/CampaignBudgetRangeForm';
import { BudgetOverview } from './budget-overview/BudgetOverview';
import { CampaignEmailing } from './campaign-emailing/CampaignEmailing';
import { CampaignEmailingForm } from './campaign-emailing/CampaignEmailingForm';
import { CampaignUpdateForm } from './components/CampaignUpdateForm';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { CampaignAdvancedEdit } from './components/CampaignAdvancedEdit';
import CampaignTransfer from './components/CampaignTransfer';

export function CampaignRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.CAMPAIGNS) && (
                <>
                    <Route path="update/:id" element={<CampaignUpdateForm />} />
                    <Route path="transfer/:id" element={<CampaignTransfer />} />
                    {hasAccessRight(AdminAclEnum.CAMPAIGN_ADVANCED_EDIT) && (
                        <Route path="advanced-edit/:id" element={<CampaignAdvancedEdit />} />
                    )}
                    <Route path="list" element={<Campaigns />} />
                    <Route path="budget" element={<BudgetOverview />} />
                    <Route path="emailing" element={<CampaignEmailing />} />
                    <Route path="emailing/preview" element={<CampaignEmailingForm />} />
                    <Route path="goals" element={<CampaignGoals />} />
                    <Route path="goals/form/:goalId?" element={<CampaignGoalForm />} />
                    <Route path="types" element={<CampaignType />} />
                    <Route path="types/form/:typeId?" element={<CampaignTypeForm />} />
                    <Route path="budget-range" element={<CampaignBudgetRange />} />
                    <Route path="budget-range/form/:budgetId?" element={<CampaignBudgetRangeForm />} />
                </>
            )}
        </Routes>
    );
}
